import {
  createInvoice as publicCreateInvoice,
  getInvoice as publicGetInvoice,
  updateInvoice as publicUpdateInvoice,
  deleteInvoice as publicDeleteInvoice,
  queryInvoices as publicQueryInvoices,
  typedQueryInvoices as publicTypedQueryInvoices,
  searchInvoices as publicSearchInvoices,
  sendInvoice as publicSendInvoice,
  publishInvoice as publicPublishInvoice,
  voidInvoice as publicVoidInvoice,
  archiveInvoice as publicArchiveInvoice,
  unarchiveInvoice as publicUnarchiveInvoice,
  initiatePayment as publicInitiatePayment,
  enableInvoicePayments as publicEnableInvoicePayments,
  generatePdfDocument as publicGeneratePdfDocument,
  markInvoiceAsViewed as publicMarkInvoiceAsViewed,
  markInvoiceAsSent as publicMarkInvoiceAsSent,
  calculateInvoice as publicCalculateInvoice,
  getLatestInvoiceNumber as publicGetLatestInvoiceNumber,
  generateReceipt as publicGenerateReceipt,
  bulkCreateInvoices as publicBulkCreateInvoices,
  bulkUpdateInvoices as publicBulkUpdateInvoices,
  bulkDeleteInvoices as publicBulkDeleteInvoices,
  bulkUpdateInvoiceTags as publicBulkUpdateInvoiceTags,
  bulkUpdateInvoiceTagsByFilter as publicBulkUpdateInvoiceTagsByFilter,
} from './invoices-invoices-v4-invoice-invoices.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  InvoiceQuery,
  InvoicesQueryBuilder,
  typedQueryInvoices as universalTypedQueryInvoices,
} from './invoices-invoices-v4-invoice-invoices.universal.js';
import { onInvoiceCreated as publicOnInvoiceCreated } from './invoices-invoices-v4-invoice-invoices.public.js';
import { onInvoiceDeleted as publicOnInvoiceDeleted } from './invoices-invoices-v4-invoice-invoices.public.js';
import { onInvoiceSent as publicOnInvoiceSent } from './invoices-invoices-v4-invoice-invoices.public.js';
import { onInvoiceTagsModified as publicOnInvoiceTagsModified } from './invoices-invoices-v4-invoice-invoices.public.js';
import { onInvoiceUpdated as publicOnInvoiceUpdated } from './invoices-invoices-v4-invoice-invoices.public.js';

function customQueryInvoices(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryInvoices(httpClient)(),
    typedQueryFunction: (query: InvoiceQuery) =>
      publicTypedQueryInvoices(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): InvoicesQueryBuilder;
  function overloadedQuery(
    query: InvoiceQuery
  ): ReturnType<typeof universalTypedQueryInvoices>;
  function overloadedQuery(query?: InvoiceQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createInvoice: MaybeContext<
  BuildRESTFunction<typeof publicCreateInvoice> & typeof publicCreateInvoice
> = /*#__PURE__*/ createRESTModule(publicCreateInvoice);
export const getInvoice: MaybeContext<
  BuildRESTFunction<typeof publicGetInvoice> & typeof publicGetInvoice
> = /*#__PURE__*/ createRESTModule(publicGetInvoice);
export const updateInvoice: MaybeContext<
  BuildRESTFunction<typeof publicUpdateInvoice> & typeof publicUpdateInvoice
> = /*#__PURE__*/ createRESTModule(publicUpdateInvoice);
export const deleteInvoice: MaybeContext<
  BuildRESTFunction<typeof publicDeleteInvoice> & typeof publicDeleteInvoice
> = /*#__PURE__*/ createRESTModule(publicDeleteInvoice);
export const searchInvoices: MaybeContext<
  BuildRESTFunction<typeof publicSearchInvoices> & typeof publicSearchInvoices
> = /*#__PURE__*/ createRESTModule(publicSearchInvoices);
export const sendInvoice: MaybeContext<
  BuildRESTFunction<typeof publicSendInvoice> & typeof publicSendInvoice
> = /*#__PURE__*/ createRESTModule(publicSendInvoice);
export const publishInvoice: MaybeContext<
  BuildRESTFunction<typeof publicPublishInvoice> & typeof publicPublishInvoice
> = /*#__PURE__*/ createRESTModule(publicPublishInvoice);
export const voidInvoice: MaybeContext<
  BuildRESTFunction<typeof publicVoidInvoice> & typeof publicVoidInvoice
> = /*#__PURE__*/ createRESTModule(publicVoidInvoice);
export const archiveInvoice: MaybeContext<
  BuildRESTFunction<typeof publicArchiveInvoice> & typeof publicArchiveInvoice
> = /*#__PURE__*/ createRESTModule(publicArchiveInvoice);
export const unarchiveInvoice: MaybeContext<
  BuildRESTFunction<typeof publicUnarchiveInvoice> &
    typeof publicUnarchiveInvoice
> = /*#__PURE__*/ createRESTModule(publicUnarchiveInvoice);
export const initiatePayment: MaybeContext<
  BuildRESTFunction<typeof publicInitiatePayment> & typeof publicInitiatePayment
> = /*#__PURE__*/ createRESTModule(publicInitiatePayment);
export const enableInvoicePayments: MaybeContext<
  BuildRESTFunction<typeof publicEnableInvoicePayments> &
    typeof publicEnableInvoicePayments
> = /*#__PURE__*/ createRESTModule(publicEnableInvoicePayments);
export const generatePdfDocument: MaybeContext<
  BuildRESTFunction<typeof publicGeneratePdfDocument> &
    typeof publicGeneratePdfDocument
> = /*#__PURE__*/ createRESTModule(publicGeneratePdfDocument);
export const markInvoiceAsViewed: MaybeContext<
  BuildRESTFunction<typeof publicMarkInvoiceAsViewed> &
    typeof publicMarkInvoiceAsViewed
> = /*#__PURE__*/ createRESTModule(publicMarkInvoiceAsViewed);
export const markInvoiceAsSent: MaybeContext<
  BuildRESTFunction<typeof publicMarkInvoiceAsSent> &
    typeof publicMarkInvoiceAsSent
> = /*#__PURE__*/ createRESTModule(publicMarkInvoiceAsSent);
export const calculateInvoice: MaybeContext<
  BuildRESTFunction<typeof publicCalculateInvoice> &
    typeof publicCalculateInvoice
> = /*#__PURE__*/ createRESTModule(publicCalculateInvoice);
export const getLatestInvoiceNumber: MaybeContext<
  BuildRESTFunction<typeof publicGetLatestInvoiceNumber> &
    typeof publicGetLatestInvoiceNumber
> = /*#__PURE__*/ createRESTModule(publicGetLatestInvoiceNumber);
export const generateReceipt: MaybeContext<
  BuildRESTFunction<typeof publicGenerateReceipt> & typeof publicGenerateReceipt
> = /*#__PURE__*/ createRESTModule(publicGenerateReceipt);
export const bulkCreateInvoices: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateInvoices> &
    typeof publicBulkCreateInvoices
> = /*#__PURE__*/ createRESTModule(publicBulkCreateInvoices);
export const bulkUpdateInvoices: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateInvoices> &
    typeof publicBulkUpdateInvoices
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateInvoices);
export const bulkDeleteInvoices: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteInvoices> &
    typeof publicBulkDeleteInvoices
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteInvoices);
export const bulkUpdateInvoiceTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateInvoiceTags> &
    typeof publicBulkUpdateInvoiceTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateInvoiceTags);
export const bulkUpdateInvoiceTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateInvoiceTagsByFilter> &
    typeof publicBulkUpdateInvoiceTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateInvoiceTagsByFilter);
export const queryInvoices: MaybeContext<
  BuildRESTFunction<typeof customQueryInvoices> & typeof customQueryInvoices
> = /*#__PURE__*/ createRESTModule(customQueryInvoices);
/**
 * Triggered when an invoice is created.
 */
export const onInvoiceCreated: BuildEventDefinition<
  typeof publicOnInvoiceCreated
> &
  typeof publicOnInvoiceCreated = /*#__PURE__*/ createEventModule(
  publicOnInvoiceCreated
);
/**
 * Triggered when an invoice is deleted.
 */
export const onInvoiceDeleted: BuildEventDefinition<
  typeof publicOnInvoiceDeleted
> &
  typeof publicOnInvoiceDeleted = /*#__PURE__*/ createEventModule(
  publicOnInvoiceDeleted
);
/**
 * Triggered when an invoice is sent to a customer.
 */
export const onInvoiceSent: BuildEventDefinition<typeof publicOnInvoiceSent> &
  typeof publicOnInvoiceSent =
  /*#__PURE__*/ createEventModule(publicOnInvoiceSent);
/**
 * Triggered when an invoice's tags are modified.
 */
export const onInvoiceTagsModified: BuildEventDefinition<
  typeof publicOnInvoiceTagsModified
> &
  typeof publicOnInvoiceTagsModified = /*#__PURE__*/ createEventModule(
  publicOnInvoiceTagsModified
);
/**
 * Triggered when an invoice is updated.
 */
export const onInvoiceUpdated: BuildEventDefinition<
  typeof publicOnInvoiceUpdated
> &
  typeof publicOnInvoiceUpdated = /*#__PURE__*/ createEventModule(
  publicOnInvoiceUpdated
);

export {
  Status,
  StatusQualifier,
  Action,
  ReferenceType,
  VatType,
  LineItemType,
  LineItemDiscountDiscountType,
  PresetType,
  PickupMethod,
  AdditionalFeeSource,
  DiscountType,
  DepositType,
  PaymentType,
  PaymentStatus,
  ReceiptType,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  Type,
  EntranceEffectType,
  LoopEffectType,
  PointerEffectType,
  TextAlignment,
  LineCap,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Variant,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  LayoutDataBackgroundType,
  Origin,
  BannerPosition,
  LayerEffect,
  Shape,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  DocumentStatus,
  FileState,
  ErrorType,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  NestedAggregationType,
  Interval,
  AggregationType,
  Mode,
  SendErrorType,
  RuleType,
  WebhookIdentityType,
} from './invoices-invoices-v4-invoice-invoices.universal.js';
export {
  Invoice,
  SourceReference,
  Reference,
  ReferenceReferenceOptionsOneOf,
  Standalone,
  Order,
  Migrated,
  AutoCharge,
  RegionalProperties,
  Locale,
  Numbering,
  CustomerInfo,
  FullAddressContactDetails,
  VatId,
  Address,
  StreetAddress,
  AddressLocation,
  ShippingInfo,
  BusinessDetails,
  LineItem,
  LineItemLineItemOptionsOneOf,
  CustomItem,
  CatalogReference,
  LineItemDiscount,
  LineItemDiscountDiscountOptionsOneOf,
  LineItemTaxInfo,
  LineItemTaxBreakdown,
  LineItemTotals,
  SubscriptionInfo,
  Cycle,
  CycleCycleOptionsOneOf,
  Weekly,
  Monthly,
  Yearly,
  CatalogItem,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  ShipmentInfo,
  DeliveryLogistics,
  DeliveryTimeSlot,
  PickupDetails,
  ShipmentRegion,
  ShipmentTaxInfo,
  ShipmentTaxBreakdown,
  ShipmentTotals,
  AdditionalFee,
  Discount,
  DiscountDiscountOptionsOneOf,
  Deposit,
  DepositDepositOptionsOneOf,
  TaxInfo,
  TaxBreakdown,
  Payment,
  PaymentPaymentOptionsOneOf,
  PaymentReceiptOptionsOneOf,
  RegularPaymentDetails,
  CreditCardDetails,
  GiftCardPaymentDetails,
  WixReceipt,
  ExternalReceipt,
  CashRounding,
  Totals,
  CustomFields,
  CustomField,
  FooterContent,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  Animation,
  EntranceAnimation,
  EntranceEffect,
  LoopAnimation,
  LoopEffect,
  PointerEffect,
  CodeBlockData,
  TextStyle,
  DividerData,
  DividerDataStyles,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  ImageDataCrop,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  Settings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  SketchData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackground,
  Layers,
  LayoutDataBackgroundImage,
  Banner,
  Backdrop,
  SectionDivider,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  PresetProperties,
  InvoicePreset,
  DisplaySettings,
  BusinessDisplayOptions,
  CustomerDisplayOptions,
  ItemsDisplayOptions,
  TotalsDisplayOptions,
  PaymentsDisplayOptions,
  DomainCustomFields,
  DomainCustomField,
  CustomFieldPlaceholder,
  DisplayValues,
  Attachment,
  DocumentInfo,
  Links,
  BusinessLocation,
  ActivityInfo,
  Tags,
  TagList,
  InvoiceNumberingProcess,
  InvoiceDocumentProcess,
  InvoiceDocumentHandled,
  InvoiceDocumentHandledResultOneOf,
  Succeeded,
  Failed,
  MediaFileStateChanged,
  SideEffectsTriggerRequested,
  SiteTaxesMigrationRequested,
  TagsModified,
  InvoiceSent,
  CreateInvoiceRequest,
  CreateInvoiceResponse,
  GetInvoiceRequest,
  GetInvoiceResponse,
  UpdateInvoiceRequest,
  UpdateInvoiceResponse,
  IllegalActionErrorData,
  ConvertInvoiceRequest,
  ConvertInvoiceResponse,
  DeleteInvoiceRequest,
  DeleteInvoiceResponse,
  QueryInvoicesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryInvoicesResponse,
  CursorPagingMetadata,
  Cursors,
  SearchInvoicesRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  SearchDetails,
  SearchInvoicesResponse,
  PagingMetadataV2,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  SendInvoiceRequest,
  SendInvoiceResponse,
  SendResult,
  PublishInvoiceRequest,
  PublishInvoiceResponse,
  VoidInvoiceRequest,
  VoidInvoiceResponse,
  ArchiveInvoiceRequest,
  ArchiveInvoiceResponse,
  UnarchiveInvoiceRequest,
  UnarchiveInvoiceResponse,
  InitiatePaymentRequest,
  InitiatePaymentResponse,
  EnableInvoicePaymentsRequest,
  EnableInvoicePaymentsResponse,
  GeneratePdfDocumentRequest,
  GeneratePdfDocumentResponse,
  MarkInvoiceAsViewedRequest,
  MarkInvoiceAsViewedResponse,
  MarkInvoiceAsSentRequest,
  MarkInvoiceAsSentResponse,
  CalculateInvoiceRequest,
  CalculateInvoiceResponse,
  ShipmentOption,
  DeliveryLogisticsOption,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ApplicationError,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  GetLatestInvoiceNumberRequest,
  GetLatestInvoiceNumberResponse,
  InternalCountInvoicesRequest,
  InternalCountInvoicesResponse,
  GenerateReceiptRequest,
  GenerateReceiptResponse,
  BulkCreateInvoicesRequest,
  BulkCreateInvoicesResponse,
  ItemMetadata,
  BulkInvoiceResult,
  BulkActionMetadata,
  BulkUpdateInvoicesRequest,
  MaskedInvoice,
  BulkUpdateInvoicesResponse,
  BulkUpdateInvoicesResponseBulkInvoiceResult,
  BulkDeleteInvoicesRequest,
  BulkDeleteInvoicesResponse,
  BulkDeleteInvoicesResponseBulkInvoiceResult,
  BulkUpdateInvoiceTagsRequest,
  BulkUpdateInvoiceTagsResponse,
  BulkUpdateInvoiceTagsResult,
  BulkUpdateInvoiceTagsByFilterRequest,
  BulkUpdateInvoiceTagsByFilterResponse,
  AddPaymentRequest,
  AddPaymentResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  InvoiceCreatedEnvelope,
  InvoiceDeletedEnvelope,
  InvoiceSentEnvelope,
  InvoiceTagsModifiedEnvelope,
  InvoiceUpdatedEnvelope,
  UpdateInvoice,
  InvoicesQueryResult,
  InvoicesQueryBuilder,
  InvoiceQuerySpec,
  InvoiceSearchSpec,
  SendInvoiceOptions,
  CalculateInvoiceOptions,
  GetLatestInvoiceNumberOptions,
  BulkCreateInvoicesOptions,
  BulkUpdateInvoicesOptions,
  BulkUpdateInvoiceTagsOptions,
  BulkUpdateInvoiceTagsByFilterOptions,
} from './invoices-invoices-v4-invoice-invoices.universal.js';
export { utils } from './invoices-invoices-v4-invoice-invoices.universal.js';
export {
  StatusWithLiterals,
  StatusQualifierWithLiterals,
  ActionWithLiterals,
  ReferenceTypeWithLiterals,
  VatTypeWithLiterals,
  LineItemTypeWithLiterals,
  LineItemDiscountDiscountTypeWithLiterals,
  PresetTypeWithLiterals,
  PickupMethodWithLiterals,
  AdditionalFeeSourceWithLiterals,
  DiscountTypeWithLiterals,
  DepositTypeWithLiterals,
  PaymentTypeWithLiterals,
  PaymentStatusWithLiterals,
  ReceiptTypeWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TypeWithLiterals,
  EntranceEffectTypeWithLiterals,
  LoopEffectTypeWithLiterals,
  PointerEffectTypeWithLiterals,
  TextAlignmentWithLiterals,
  LineCapWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  VariantWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  LayerEffectWithLiterals,
  ShapeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  DocumentStatusWithLiterals,
  FileStateWithLiterals,
  ErrorTypeWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  IntervalWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  SendErrorTypeWithLiterals,
  RuleTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateInvoiceApplicationErrors,
  CreateInvoiceValidationErrors,
  GetInvoiceApplicationErrors,
  UpdateInvoiceApplicationErrors,
  UpdateInvoiceValidationErrors,
  DeleteInvoiceApplicationErrors,
  QueryInvoicesApplicationErrors,
  SendInvoiceApplicationErrors,
  PublishInvoiceApplicationErrors,
  VoidInvoiceApplicationErrors,
  ArchiveInvoiceApplicationErrors,
  UnarchiveInvoiceApplicationErrors,
  InitiatePaymentApplicationErrors,
  EnableInvoicePaymentsApplicationErrors,
  GeneratePdfDocumentApplicationErrors,
  CalculateInvoiceApplicationErrors,
  BulkCreateInvoicesApplicationErrors,
  BulkCreateInvoicesValidationErrors,
  BulkUpdateInvoicesApplicationErrors,
  BulkUpdateInvoicesValidationErrors,
  BulkUpdateInvoiceTagsApplicationErrors,
  BulkUpdateInvoiceTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  InvoiceQuery,
  CommonSearchWithEntityContext,
  InvoiceSearch,
} from './invoices-invoices-v4-invoice-invoices.universal.js';
